import { Map, List } from 'immutable';
import { FETCH_STUDENT_TOTAL_POINTS_SUCCESS } from './actions';
import StudentTotalPoint from './model';

export default function totalPoints(state = new Map(), action) {
  switch (action.type) {
    case FETCH_STUDENT_TOTAL_POINTS_SUCCESS:
      return state.set(action.groupId,
          new List(action.payload.map((item) => StudentTotalPoint.create(item))));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/TotalPoint/reducer.js